import { Show } from "../../../../constants/schema.js";
import { bHas } from "../../../../utils/bit.js";
import { SelectType } from "../state.js";
//#region src/engine/modules/editor/utils/releaseHidden.ts
var dropSelected = (state, type) => {
	Object.entries(state.editor.selectedMap).forEach(([id, selected]) => {
		if (selected === type) Reflect.deleteProperty(state.editor.selectedMap, id);
	});
};
function releaseTableGroups(state) {
	dropSelected(state, SelectType.tableGroup);
	state.editor.drawTableGroup = false;
	state.editor.editTableGroupId = null;
}
function releaseMemos(state) {
	dropSelected(state, SelectType.memo);
	state.editor.editMemoId = null;
}
function releaseHidden(state) {
	const { show } = state.settings;
	if (bHas(show, Show.hideTableGroup)) releaseTableGroups(state);
	if (bHas(show, Show.hideMemo)) releaseMemos(state);
}
//#endregion
export { releaseHidden, releaseMemos, releaseTableGroups };
